<template>
  <div
    v-if="isCurrentApp"
    class="webtool current-app"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div
      class="webtool-icon-container"
    >
      <img
        class="webtool-icon"
        :src="iconSrc"
        alt=""
      >
    </div>
    <div
      class="webtool-text-container"
    >
      <div>
        <p class="app-name">
          {{ appData.title }}
        </p>
        <p class="app-subtitle">
          {{ appData.subtitle }}
        </p>
      </div>
    </div>
    <div class="nav-selection-underline-static" />

    <!-- Info Icon + Progress Circle -->
    <info-progress-circle
      v-if="appData.showInfoIcon"
      :progress-offset="progressOffset"
      :background-color="headerBackgroundColor"
    />
    <app-info-card
      :visible="appData.popupVisible"
      :app-data="appData"
    />
  </div>
  <div
    v-else
    :href="appLink"
    :class="[
      'webtool notcurrentapp',
      { userdoesnthaveaccess: !appData.userAccess }
    ]"
    @click="clickedTool"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div
      class="webtool-icon-container"
      :style="{ opacity: appData.userAccess ? 1 : 0.4 }"
    >
      <img
        class="webtool-icon"
        :src="iconSrc"
        alt=""
      >
    </div>
    <div
      class="webtool-text-container"
      :style="{ opacity: appData.userAccess ? 1 : 0.4 }"
    >
      <div>
        <p class="app-name">
          {{ appData.title }}
        </p>
        <p class="app-subtitle">
          {{ appData.subtitle }}
        </p>
      </div>
    </div>
    <div class="nav-selection-underline" />

    <!-- Info Icon + Progress Circle -->
    <info-progress-circle
      v-if="appData.showInfoIcon"
      :progress-offset="progressOffset"
      :background-color="headerBackgroundColor"
    />
    <app-info-card
      :visible="appData.popupVisible"
      :app-data="appData"
    />
  </div>
</template>

<script>
import InfoProgressCircle from "./InfoProgressCircle.vue"
import AppInfoCard from "./AppInfoCard.vue"

export default {
    name: "AppNavItem",
    components: {
        AppInfoCard,
        InfoProgressCircle,
    },
    props: {
        appId: {
            type: String,
            required: true,
        },
        appData: {
            type: Object,
            required: true,
        },
        isCurrentApp: {
            type: Boolean,
            default: false,
        },
        appIndex: {
            type: Number,
            required: true,
        },
        showInfoIcon: {
            type: Boolean,
            default: false,
        },
        progressOffset: {
            type: Number,
            default: 62.8,
        },
        appLink: {
            type: String,
            default: "#",
        },
        iconSrc: {
            type: String,
            required: true,
        },
        headerBackgroundColor: {
            type: String,
            default: "#337ab7",
        },
    },
    methods: {
        onMouseEnter() {
            this.$emit("start-hover", this.appIndex)
        },
        onMouseLeave() {
            this.$emit("stop-hover")
        },
        clickedTool() {
            if (this.appData.userAccess)
                window.open(this.appLink, "_self")
        },
    },
}
</script>

<style scoped>
.notcurrentapp {
    cursor: pointer;
}
.userdoesnthaveaccess {
  user-select: none;
  cursor: not-allowed;
}
</style>
<style>
/* Basic container styles */
.webtool {
    position: relative;
    margin: 0;
    padding: 0 min(40px, max(10px, 10px + ((100vw - 1600px) * 0.02)));
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: auto;
    color: white !important;
    text-decoration: none !important;
}

.webtool:hover {
    text-decoration: none !important;
    background-color: rgba(25, 80, 129, 0.2);
    border-radius: 0;
    color: white !important;
}

/* Current app styling with info cursor on hover */
.current-app {
    cursor: help;
}

/* Icon and text container styles */
.webtool-icon-container {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    width: 2.75rem;
}

.webtool-icon-container img {
    width: 36px;
    height: 36px;
    object-fit: contain;
}

.webtool-text-container {
    flex: 0 1 auto;
    text-align: left;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    padding-right: 5px;
}

/* Underline styles */
.nav-selection-underline {
    transition: background-color 100ms ease-in-out;
    background-color: transparent;
    position: absolute;
    width: 100%;
    height: 0;
    bottom: 0;
    left: 0;
}

.nav-selection-underline-static {
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: 10px;
    left: 0;
    background-color: white;
}

.webtool:hover .nav-selection-underline {
    background-color: transparent;
}

/* Text styles */
.app-name {
    font-size: 0.9rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    white-space: nowrap;
    margin: 0;
    line-height: 1.2;
    color: white !important;
}

.app-subtitle {
    font-size: 0.65rem !important;
    white-space: nowrap;
    margin: 0;
    opacity: 0.8;
    line-height: 1.2;
    color: white !important;
}

/* Large screens (>1700px): Slightly smaller icon and text sizes */
@media (min-width: 1701px) {
    .webtool-icon-container img {
        width: 32px;
        height: 32px;
    }

    .app-name {
        font-size: 0.82rem;
        letter-spacing: 0.02em;
    }

    .app-subtitle {
        font-size: 0.6rem !important;
    }

    .webtool {
        padding: 0 min(35px, max(15px, 15px + ((100vw - 1700px) * 0.01)));
    }
}

/* Media query styles */
@media (min-width: 1500px) and (max-width: 1700px) {
    .app-subtitle {
        display: none;
    }

    .webtool {
        padding: 0 min(30px, max(5px, 5px + ((100vw - 1200px) * 0.02)));
    }

    .webtool-icon-container {
        margin-right: 0px;
    }

    .webtool-icon-container img {
        width: 24px;
        height: 24px;
    }

    .app-name {
        font-size: 0.8rem !important;
        font-weight: 400 !important;
        letter-spacing: 0em;
    }
}

@media (min-width: 1100px) and (max-width: 1499px) {
    .webtool-text-container {
        display: none !important;
    }

    .webtool {
        padding-right: 15px !important;
        padding-left: 15px !important;
        justify-content: center;
    }

    .webtool-icon-container {
        margin-right: 0;
    }

    .webtool-icon-container img {
        width: 32px;
        height: 32px;
    }

    .nav-selection-underline-static {
        bottom: 5px;
    }
}
</style>
